import { createFilteredUrlParams } from "../utils/createFilteredUrlParams";
import { IPylonDataProps } from "../hooks/usePylonSignature";

const pylon = "/api/pylon";

const ENDPOINTS = {
  fetchPylonSignature: (params: IPylonDataProps) =>
    `${pylon}?${createFilteredUrlParams<IPylonDataProps>(params)}`,
};

export { ENDPOINTS };
